const SEARCH_INPUT_CLASS = '.js-search-input';
const SEARCH_OPEN_CLASS = 'has-search-open';

const $header = $('.js-header');
const $searchTrigger = $('.js-header-search-trigger');
const $searchClose = $('.js-search-bar-close');
const $searchBar = $('.js-search-bar');

let $lastTrigger;

const SEARCH_FOCUS_TIMEOUT = 50;

const headerSearch = {
  initialize() {
    if ($searchTrigger.length) {
      this.createEvents();
    }
  },

  /**
   * Create all events for the search in the header
   * @return {void}
   */
  createEvents() {
    $searchTrigger.add($searchClose).on('click touchstart', (e) => {
      e.stopPropagation();
      e.preventDefault();

      // Check if the search is currently open
      const isOpen = $header.hasClass(SEARCH_OPEN_CLASS);

      // Toggle the search opened/closed
      $header.toggleClass(SEARCH_OPEN_CLASS, !isOpen);

      if (!isOpen) {
        // Focus on the search input field
        this.focusOn($searchBar.find(SEARCH_INPUT_CLASS));
      } else if (typeof $lastTrigger !== 'undefined') {
        // Put the focus back on the trigger that opened the search in the first place
        this.focusOn($lastTrigger);
      }

      // Save the trigger to put the focus back on close
      $lastTrigger = $(e.currentTarget);
    });
  },

  /**
   * Focus on element
   * @param {object} $el jQuery element object
   * @return {void}
   */
  focusOn($el) {
    setTimeout(() => {
      $el.focus();
    }, SEARCH_FOCUS_TIMEOUT);
  },
};

export default headerSearch;
